import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AirbnbOfficialNotificationModel extends Model {
  @attr('string') type!: string;
  @attr('string') title!: string;
  @attr('string') subtitle!: string;
  @attr('string') description!: string;
  @attr('string') ctaUrl!: string;

  @belongsTo('channel-notification', {
    inverse: 'airbnbOfficialNotifications',
    async: false,
  })
  channelNotification!: ModelRegistry['channel-notification'];

  @belongsTo('airbnb-official-connection', { inverse: null, async: false })
  airbnbOfficialConnection!: ModelRegistry['airbnb-official-connection'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-official-notification': AirbnbOfficialNotificationModel;
  }
}
